module.exports = __webpack_public_path__ + "static/media/Steenee_gaussian2.a5557ce1.png";